import { Component, Input, OnInit } from '@angular/core';
import { nanoid } from 'nanoid';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { PlayerSessionService } from 'src/app/services/player-session.service';
import { PlayerService } from 'src/app/services/player.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-inventory',
  templateUrl: './inventory.component.html',
  styleUrls: ['./inventory.component.scss'],
})
export class InventoryComponent implements OnInit {
  @Input() scenario: any;
  @Input() items: any;
  public picked: any = [];
  public playerInventroy: any = [];

  itemAnimationClass: any;
  itemAnimationStyle: any;

  constructor(
    public bsModalRef: BsModalRef,
    private playerSessionService: PlayerSessionService,
    public playerService: PlayerService
  ) {}

  ngOnInit(): void {
    this.playerInventroy = this.playerSessionService.sessionData.inventory;
    if (!this.scenario.inventory) {
      this.scenario.inventory = {
        items: [],
        actions: [],
      };
    }
    if (!this.scenario.inventory.items) {
      this.scenario.inventory.items = [];
    }
    if (!this.scenario.inventory.actions) {
      this.scenario.inventory.actions = [];
    }

    if (this.items) {
      this.playerInventroy = this.items;
    }

    this.scenario.inventory.items.forEach((item: any) => {
      if (!item.id) {
        item.id = nanoid(12);
      }
    });

    this.itemAnimationClass = this.getItemClass();
    this.itemAnimationStyle = this.getItemStyle();
  }

  onPickItem(item: any) {
    if (!this.picked) {
      this.picked = [];
    }
    if (this.picked.indexOf(item) == -1) {
      this.picked.push(item);
    } else {
      this.picked.splice(this.picked.indexOf(item), 1);
    }
  }

  itemIsPicked(item: any) {
    if (this.picked) {
      return this.picked.indexOf(item) !== -1;
    } else {
      return false;
    }
  }

  onUseItems() {
    this.playerSessionService.addToLog('useInventoryItems', {
      items: JSON.parse(JSON.stringify(this.picked)),
    });

    this.playerSessionService.sessionData.inventory.picked = this.picked;
    let actionsPerformed = this.playerService.doActions(
      this.scenario.inventory.actions,
      'inventory',
      this.scenario.inventory
    );
    this.picked = [];
    if (
      actionsPerformed == 0 &&
      !this.scenario.inventory?.settings?.disableNothingHappened
    ) {
      Swal.fire({
        customClass: { container: 'ys-swal' },
        title: this.scenario.inventory?.settings?.nothingHappenedText
          ? this.scenario.inventory?.settings?.nothingHappenedText
          : 'Nothing useful happened',
        icon: 'info',
        position: 'center',
      });
    }
  }

  onHideInventory() {
    this.bsModalRef.hide();
    this.playerService.toggleInventory.next(false);
  }

  getItemClass() {
    let animClass = '';
    if (this.scenario.style.inventoryItemAnimationIn) {
      animClass =
        'animate__animated animate__delay-1s animate__' +
        this.scenario.style.inventoryItemAnimationIn.name;
    }
    return animClass;
  }

  getItemStyle() {
    let animStyle = '';
    if (this.scenario.style.inventoryItemAnimationIn) {
      animStyle =
        '--animate-duration:' +
        this.scenario.style.inventoryItemAnimationIn.speed +
        's;--animate-delay:' +
        this.scenario.style.inventoryItemAnimationIn.delay +
        's;';
    }

    // is there a font

    if (this.scenario.style.inventoryItemFont) {
      switch (this.scenario.style.inventoryItemFont) {
        case 'body':
          animStyle += '--ys-inventory-item-font: var(--ys-font-base);';
          break;
        case 'sans':
          animStyle += '--ys-inventory-item-font: var(--ys-font-sans);';
          break;
        case 'serif':
          animStyle += '--ys-inventory-item-font: var(--ys-font-serif);';
          break;
        case 'heading':
          animStyle += '--ys-inventory-item-font: var(--ys-font-heading);';
          break;
        case 'mono':
          animStyle += '--ys-inventory-item-font: var(--ys-font-mono);';
          break;
        case 'script':
          animStyle += '--ys-inventory-item-font:var(--ys-font-script);';
          break;
        case 'custom':
          // load the custom font!

          animStyle +=
            '--ys-inventory-item-font: ' +
            this.scenario.style.inventoryItemFontFamily +
            ';';
          break;
      }
    }

    return animStyle;
  }
}
